.component {
  background: var(--color-body);
  border: 1px solid var(--color-body);
  border-radius: var(--border-radius-s);
  position: relative;
  transition: background 0.15s ease-in-out, border 0.15s ease-in-out;

  &.isEditing {
    background: #fff;
    border: 1px solid #c7d8df;
  }
}

.component:hover {
  &:not(.isEditing).isEditable {
    background: #fff;
    border: 1px solid #c7d8df;
  }
}
